module.exports = __webpack_public_path__ + "img/Sezione_Design.522d0e73.jpg";